import BaseModelFactory from './base.factory'
import CarrierProductService from './../services/CarrierProduct.service'
import CarrierProduct from './../models/carrier-product.model'

class CarrierProductFactory extends BaseModelFactory {
  static search = async ({ search, pagination, order_by, method }) =>
    await this._search(
      { search, pagination, order_by, method },
      { Service: CarrierProductService, Model: CarrierProduct }
    )
  static findAll = async () => await this._findAllBy({}, { Service: CarrierProductService, Model: CarrierProduct })
  static findById = async id =>
    await this._findBy({ id: id }, { Service: CarrierProductService, Model: CarrierProduct })
  static findAllByCarrierId = async id =>
    await this._findAllBy({ carrier_id: id }, { Service: CarrierProductService, Model: CarrierProduct })
  static create = payload =>
    this._create(payload, {
      Service: CarrierProductService,
      Model: CarrierProduct,
    })
}

export default CarrierProductFactory
